import { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { adminApi, getApiErrorMessage } from '../services/adminApi'
import { Alert, Badge, Button, Card, ConfirmAction, EmptyState, PageHeader, Spinner } from '../components/ui'

export default function Revendas() {
  const navigate = useNavigate()
  const location = useLocation()
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [message, setMessage] = useState(location.state?.message || '')

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const { data } = await adminApi.listRevendas()
      setItems(data.data || [])
    } catch (err) {
      setError(getApiErrorMessage(err))
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    load()
  }, [load])

  const toggleBlock = async (id) => {
    try {
      await adminApi.blockRevenda(id)
      load()
    } catch (err) {
      setError(getApiErrorMessage(err))
    }
  }

  const remove = async (id) => {
    try {
      await adminApi.deleteRevenda(id)
      setMessage('Revenda excluída.')
      load()
    } catch (err) {
      setError(getApiErrorMessage(err))
    }
  }

  const syncPortal = async (id) => {
    try {
      const { data } = await adminApi.syncRevendaPortal(id)
      setMessage(data.message || 'Base sincronizada.')
      load()
    } catch (err) {
      setError(getApiErrorMessage(err))
    }
  }

  if (loading) return <Spinner />

  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Parceiros" title="Revendas" description={`${items.length} parceiro(s) cadastrado(s).`} icon="fa-handshake" actions={<Button icon="fa-plus" onClick={() => navigate('/revendas/new')}>Nova revenda</Button>} />
      {error && <Alert type="error">{error}</Alert>}
      {message && <Alert type="success">{message}</Alert>}

      <Card bodyClassName="!p-0">
        <div className="mp-scrollbar overflow-x-auto">
        <table className="w-full min-w-[760px] text-left text-sm">
          <thead>
            <tr className="border-b bg-slate-50/80 text-xs uppercase tracking-wide text-slate-500">
              <th className="px-5 py-3.5">Tenant</th>
              <th className="px-5 py-3.5">Razão social</th>
              <th className="px-5 py-3.5">Admin</th>
              <th className="px-5 py-3.5">Status</th>
              <th className="px-5 py-3.5">Ações</th>
            </tr>
          </thead>
          <tbody>
            {items.map((r) => (
              <tr key={r.id} className="border-b border-slate-100 transition hover:bg-blue-50/40">
                <td className="px-5 py-4 font-mono text-xs">{r.tenant_id}</td>
                <td className="px-5 py-4 font-semibold text-brand-deep">{r.corporate_name}</td>
                <td className="px-5 py-4 text-xs">{r.admin_email}</td>
                <td className="px-5 py-4">
                  <Badge tone={r.active ? 'success' : 'danger'}>{r.active ? 'Ativa' : 'Bloqueada'}</Badge>
                </td>
                <td className="px-5 py-4">
                  <div className="flex flex-wrap gap-1">
                    <Button variant="outline" className="!px-2 !py-1 text-xs" onClick={() => syncPortal(r.id)}>
                      Sincronizar base
                    </Button>
                    <Button variant="outline" className="!px-2 !py-1 text-xs" onClick={() => toggleBlock(r.id)}>
                      {r.active ? 'Bloquear' : 'Desbloquear'}
                    </Button>
                    <ConfirmAction className="!px-2 !py-1 text-xs" onConfirm={() => remove(r.id)} />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!items.length && <EmptyState title="Nenhuma revenda cadastrada" icon="fa-handshake" />}
        </div>
      </Card>
    </div>
  )
}
